import { render } from "./TeamLeadDashboard.vue?vue&type=template&id=6bb3e21b"
import script from "./TeamLeadDashboard.vue?vue&type=script&lang=js"
export * from "./TeamLeadDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__